export default __webpack_public_path__ + "img/benefits8.b4a6d55a.svg";